export type RouteName =
  | "auth"
  | "dashboard"
  | "rescues"
  | "obligations"
  | "aiEvaluation"
  | "security"
  | "inbox"
  | "review"
  | "leads"
  | "entity"
  | "thread"
  | "customer"
  | "triageRules"
  | "slaRules"
  | "lens"
  | "team"
  | "orgInvite"
  | "settings"
  | "integrations"
  | "billing"
  | "orgSetup";

export type RouteInfo = {
  name: RouteName;
  params: {
    entityId?: string;
    threadId?: string;
    customerId?: string;
    lensKey?: string;
    rescueCaseId?: string;
  };
};

export function parseRoute(pathname: string): RouteInfo {
  if (pathname === "/settings/team") return { name: "team", params: {} };
  if (pathname === "/invite") return { name: "orgInvite", params: {} };
  if (pathname === "/ai-evaluation") return { name: "aiEvaluation", params: {} };
  if (pathname === "/obligations") {
    return { name: "obligations", params: {} };
  }
  if (pathname === "/rescues") {
    return { name: "rescues", params: {} };
  }
  if (pathname.startsWith("/rescues/")) {
    return { name: "rescues", params: { rescueCaseId: pathname.replace("/rescues/", "") } };
  }
  if (pathname === "/dashboard") {
    return { name: "dashboard", params: {} };
  }
  if (pathname === "/security") {
    return { name: "security", params: {} };
  }
  if (pathname === "/inbox") {
    return { name: "inbox", params: {} };
  }
  if (pathname === "/review") {
    return { name: "review", params: {} };
  }
  if (pathname === "/leads") {
    return { name: "leads", params: {} };
  }
  if (pathname.startsWith("/entities/")) {
    return { name: "entity", params: { entityId: pathname.replace("/entities/", "") } };
  }
  if (pathname.startsWith("/threads/")) {
    return { name: "thread", params: { threadId: pathname.replace("/threads/", "") } };
  }
  if (pathname.startsWith("/customers/")) {
    return {
      name: "customer",
      params: { customerId: pathname.replace("/customers/", "") },
    };
  }
  if (pathname === "/triage-rules") {
    return { name: "triageRules", params: {} };
  }
  if (pathname === "/sla-rules") {
    return { name: "slaRules", params: {} };
  }
  if (pathname === "/settings") {
    return { name: "settings", params: {} };
  }
  if (pathname === "/settings/integrations") {
    return { name: "integrations", params: {} };
  }
  if (pathname === "/billing") {
    return { name: "billing", params: {} };
  }
  if (pathname === "/orgs/setup") {
    return { name: "orgSetup", params: {} };
  }
  if (pathname.startsWith("/lens/")) {
    return { name: "lens", params: { lensKey: pathname.replace("/lens/", "") } };
  }
  return { name: "auth", params: {} };
}

export function isProtectedRoute(route: RouteName) {
  return route !== "auth";
}
